import React from 'react';

import RichTextEditor from 'react-rte';

import './HTMLEditor.scss';

interface Props {
  value?: string;
  error?: string;
  placeholder?: string;
  disabled?: boolean;
  onChange: (val: any) => void;
}
const HTMLEdior: React.FC<Props> = (props) => {
  const [val, setVal] = React.useState<any>(RichTextEditor.createValueFromString(props.value || '', 'html'))

  React.useEffect(() => {
    const res = val.toString('html')
    const old = props.value || ''
    if (res !== old) {
      props.onChange(res)
    }
  }, [props.value, val])

  return (
    <RichTextEditor
      placeholder={(props.placeholder || '').toUpperCase()}
      value={val}
      disabled={props.disabled}
      onChange={(v) => setVal(v)}
      />
  );
}

export default HTMLEdior

